export enum StorageKeys {
  Token = "nuveToken",
  EnterpriseMasterAccountToken = "nuveEnterpriseMasterAccountToken",
  EnterpriseContractorsMenuDropdown = "nuveEnterpriseContractorsMenuDropdown",
  IsPrivacyChecked = "nuveIsPrivacyChecked",
  UserProfile = "nuveUserProfile",
  TechnicianSN = "nuveTechnicianSN",
  UserTemperatureScale = "userTemperatureScale",
  UserTheme = "userTheme",
  UserLogo = "userLogo",
  VerticalMenuOpen = "verticalMenuOpen",
  EnabledFeatureFlags = "nuveEnabledFeatureFlags",
}
